import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Table, Row, Badge, Divider } from 'antd';
import { DeleteIcon, EditIcon, ExcelIcon } from 'icons';
import { Link, Route, Routes, useLocation } from 'react-router-dom';
import DeleteModal from 'components/deleteModalView';
// import Filters from './filters';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import useUserVacancies from '../useUserVacancies';
import { useRecoilValue } from 'recoil';
import { getPage } from '../../../../../hooks/useUser';

const MainPage = () => {
  const {
    data,
    columns,
    filters,
    loading,
    handleDeactivate,
    updateInProcess,
    onChangeTableFilter,
    handleDownloadExcel,
  } = useUserVacancies();
  const { t } = useTranslation();
  const pages = useRecoilValue(getPage);

  return (
    <>
      <PageHeader title={t('Adesione privacy').toUpperCase()}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              loading={updateInProcess}
              onClick={handleDownloadExcel}
              icon={<ExcelIcon fill={'#fff'} />}
            >
              {t('Export')}
            </Button>
          </Col>
          {pages?.ability?.can_create && (
            <Col>
              <Link to={'new'}>
                <Button big icon={<PlusOutlined />}>
                  {t('Modulo richiesta adesione')}
                </Button>
              </Link>
            </Col>
          )}
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <Divider />
        <Table
          columns={columns}
          dataSource={data.user_vacancies}
          pagination={data.pagination}
          onChange={onChangeTableFilter}
          loading={loading}
          scroll={{ x: 1200 }}
          // bordered
        />
      </div>
      <Routes>
        <Route
          path={':id/deactivate'}
          element={
            <DeleteModal
              loading={updateInProcess}
              onClickDelete={handleDeactivate}
            />
          }
        />
      </Routes>
    </>
  );
};

export default MainPage;
